export default __webpack_public_path__ + "static/media/may-the-4th-appbar-tile.3375afb7.svg";